/**
 * @prettier
 */
export function isWebApp(): boolean {
    return !window.ReactNativeWebView;
}
